import script from "./HTPickGameSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./HTPickGameSetting.vue?vue&type=script&setup=true&lang=js"

import "./HTPickGameSetting.vue?vue&type=style&index=0&id=21a70120&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21a70120"]])

export default __exports__